import { z } from "zod";

export enum EGenerationStatus {
  pending = "pending",
  processing = "processing",
  streaming = "streaming",
  ready = "ready",
  processed = "processed",
  error = "error",
  cancelled = "cancelled"
}

export enum EGenerationTaskType {
  chapter = "chapter",
  claims = "claims",
  projectSetup = "projectSetup",
  chatSlides = "chatSlides"
}

export const StatusResponseSchema = z.object({
  id: z.number(),
  status: z.nativeEnum(EGenerationStatus),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  result: z.string().nullish(),
  type: z.nativeEnum(EGenerationTaskType),
  chapterId: z.number().nullish(),
  prereqs: z.array(z.string()).optional()
});

export const StatusAllResponseSchema = z.object({
  tasks: z.array(StatusResponseSchema)
});

export type TChapterInProgressState = {
  generationId: number;
  chapterId: number;
  fullChapterGenerationStartedAt: Date | null; // null if not full chapter generation
};
